import { makeId } from "@/common/id"

export type Listener<T> = (data: T | undefined) => void

export class Stream<T> {
    #current: T | undefined
    #inited: boolean = false
    #listeners = new Map<string, Listener<T>>()

    constructor() {}

    send(data: T | undefined) {
        this.#current = data
        this.#inited = true
        this.#listeners.forEach((listener: Listener<T>) => {
            listener(data)
        })
    }

    listen(listener: Listener<T>): string {
        var id = makeId(12)
        this.#listeners.set(id, listener)
        if(this.#inited) {
            listener(this.#current)
        }
        return id
    }

    remove(id: string) {
        this.#listeners.delete(id)
    }

    value(): T | undefined {
        return this.#current
    }
}